import React, { useState } from 'react';
import { Helmet } from "react-helmet-async";
import '../styles/advogados.css';
import seloSeguro from "../assets/selos/site-seguro.png";
import seloCloudflare from "../assets/selos/cloudflare.png";
import seloLgpd from "../assets/selos/lgpd.png";
import seloMercadoPago from "../assets/selos/mercado-pago.png";

const AdvogadosParceiros = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Estados separados para cada Modal
  const [isDocsModalOpen, setIsDocsModalOpen] = useState(false);
  const [isPromoModalOpen, setIsPromoModalOpen] = useState(false);
  const [isRefModalOpen, setIsRefModalOpen] = useState(false);
  const [isRjModalOpen, setIsRjModalOpen] = useState(false);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleEmailClick = (email, subject = "Fazer Revisão - Anexar carta e Cnis em pdf") => {
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
    window.location.href = mailtoUrl;
  };

  const handleWhatsappClick = (phone, message = "") => {
    let url = `https://wa.me/${phone}`;
    if (message) {
      url += `?text=${encodeURIComponent(message)}`;
    }
    window.open(url, '_blank');
  };

  // Função para baixar a Cartilha em PDF
  const handleDownloadCartilha = () => {
    // Ajuste o caminho abaixo para onde o arquivo PDF da cartilha está salvo na sua pasta public/assets
    const pdfUrl = "/cartilha.pdf";
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Cartilha-Basica-Direito-do-Aposentado.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Controle do Carrossel de Referências
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const referenceImages = [
    "/assets/calculo1.png",
    "/assets/calculo2.png",
    "/assets/calculo3.png",
    "/assets/calculo4.png",
    "/assets/calculo5.png",
    "/assets/calculo6.png",
    "/assets/calculo7.png",
    "/assets/calculo8.png",
    "/assets/calculo9.png",
    "/assets/calculo10.png",
    "/assets/calculo11.png",
    "/assets/calculo12.png",
    "/assets/calculo13.png",
    "/assets/calculo14.png",
    "/assets/calculo15.png",
    "/assets/calculo16.png",
    "/assets/calculo17.png",
    "/assets/calculo18.png"
  ];

  const nextImage = () => setCurrentImageIndex((prev) => (prev + 1) % referenceImages.length);
  const prevImage = () => setCurrentImageIndex((prev) => (prev === 0 ? referenceImages.length - 1 : prev - 1));

  React.useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % referenceImages.length);
    }, 2300);

    return () => clearInterval(interval);
  }, [referenceImages.length, isPaused]);

  const handlePause = () => setIsPaused(true);
  const handleResume = () => setIsPaused(false);

  return (
    <>
      <Helmet>
        <title>Especialistas em Revisão de Aposentadoria | Dr. Jerônimo Magalhães</title>
      </Helmet>

      <div className="adv-page-wrapper">
        <main className="main-content">

          {/* HERO SECTION */}
          <section className="hero-section">
            <div className="hero-text">
              <p className="hero-kicker">
                SISTEMA REVISA JÁ<br />APOSENTADORIA
              </p>
              <div className="kicker-line"></div>

              <h1>
                Descubra se sua aposentadoria está errada e faça revisão de cálculos.
              </h1>
              <div className="h1-line"></div>
            </div>

            <div className="hero-image">
              <picture>
                <source media="(min-width: 900px)" srcSet="/assets/manual/notbook-desktop-invertido.png" />
                <img
                  src="/assets/manual/notbook-desktop-invertido.png"
                  alt="Aposentados conferindo revisão de aposentadoria"
                />
              </picture>
            </div>
          </section>

          {/* ======================================================== */}
          {/* NATIONAL SERVICE - DESTAQUE DR. JERÔNIMO MAGALHÃES       */}
          {/* ======================================================== */}
          <section className="national-service">
            <div className="hero-action-box">

              <div className="office-spotlight-banner">
                <span className="pulse-dot"></span>
                <span>ATENDIMENTO PRESENCIAL NO RIO DE JANEIRO</span>
              </div>

              <div className="hero-action-content">
                <div className="lawyer-section">
                  <div className="lawyer-info">
                    <div className="badge-wrapper">
                      <span className="badge-line"></span>
                      <p className="lawyer-badge">RIO DE JANEIRO — ADVOGADO PREVIDENCIÁRIO</p>
                    </div>

                    <h2 className="lawyer-name">Dr. Jerônimo Magalhães</h2>

                    <h3 className="lawyer-pitch">
                      Fazemos revisão de calculo da sua aposentadoria.
                    </h3>

                    <div className="lawyer-address-wrapper">
                      <div className="pin-icon-box">
                        <svg className="pin-icon" viewBox="0 0 24 24" fill="#104735">
                          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                        </svg>
                      </div>
                      <div className="lawyer-address-details">
                        <span className="address-label">Nosso endereço:</span>
                        <p className="lawyer-address-text">
                          Rua Viúva Dantas, Nº 80, Sala 312<br />
                          <strong>Campo Grande - Rio de Janeiro / RJ</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="action-buttons-container">
                  <div className="btn-group-wrapper">
                    <h2>AGENDE SUA CONSULTA</h2>
                    <button
                      onClick={() => handleWhatsappClick(
                        "5521993298688",
                        "Olá! Gostaria de agendar uma data para fazer a revisão de cálculo da minha aposentadoria, solicito retorno com a data mais próxima e com as demais informações quanto aos documentos necessários, obrigado."
                      )}
                      className="btn-faca-revisao btn-whatsapp-office"
                    >
                      <svg
                        className="btn-icon whatsapp-icon-green"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.513 2.263 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.724-1.458L0 24zm6.59-4.846c1.652.981 3.271 1.497 5.338 1.499 5.54 0 10.048-4.464 10.051-9.953.001-2.659-1.03-5.158-2.905-7.037C17.255 1.785 14.773.755 12.01.755c-5.542 0-10.055 4.463-10.059 9.954-.002 1.905.495 3.766 1.439 5.413L2.433 21.6l5.725-1.503z" />
                        <path d="M17.472 14.382c-.302-.15-1.788-.882-2.057-.981-.269-.099-.465-.15-.659.15-.195.298-.754.945-.923 1.137-.17.19-.34.21-.643.06-.303-.15-1.277-.47-2.433-1.503-.898-.802-1.504-1.792-1.681-2.09-.177-.3-.02-.461.13-.61.134-.132.302-.35.452-.524.15-.174.199-.298.298-.497.099-.198.05-.372-.025-.521-.075-.15-.659-1.591-.902-2.176-.237-.571-.478-.493-.659-.503-.17-.008-.363-.009-.557-.009-.195 0-.513.073-.78.365-.269.293-1.025 1.002-1.025 2.443s1.047 2.836 1.192 3.033c.147.196 2.059 3.144 4.986 4.407.696.3 1.24.479 1.666.613.7.222 1.338.191 1.843.115.56-.084 1.788-.731 2.037-1.402.25-.671.25-1.244.175-1.366-.073-.122-.269-.215-.572-.365z" />
                      </svg>

                      <div className="btn-text-stack">
                        <span className="btn-texto-baixo">Revisão no escritório</span>
                        <span className="btn-texto-sub">Agendar consulta - WhatsApp</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ======================================================== */}
          {/* SEÇÃO DE RESULTADOS (CARROSSEL)                          */}
          {/* ======================================================== */}
          <section className="resultados-section">
            <div className="ref-section-container">
              <h2 className="ref-title">
                Nossos Resultados no Rio de Janeiro
              </h2>

              <div className="ref-carousel-wrapper">
                <button className="ref-btn-nav" onClick={prevImage} style={{ zIndex: 3 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>

                <div
                  className="ref-image-card"
                  onMouseDown={handlePause}
                  onMouseUp={handleResume}
                  onMouseLeave={handleResume}
                  onTouchStart={handlePause}
                  onTouchEnd={handleResume}
                >
                  <div className="ref-carousel-track">
                    <div className="ref-ghost-img">
                      <img src={referenceImages[0]} alt="" />
                    </div>

                    {referenceImages.map((imagem, index) => {
                      let offset = index - currentImageIndex;
                      const half = Math.floor(referenceImages.length / 2);

                      if (offset > half) offset -= referenceImages.length;
                      else if (offset < -half) offset += referenceImages.length;

                      const isActive = offset === 0;
                      const isAdjacent = Math.abs(offset) === 1;
                      const opacity = isActive ? 1 : (isAdjacent ? 0.35 : 0);

                      return (
                        <div
                          key={index}
                          className="ref-slide-item"
                          style={{
                            transform: `translateX(${offset * 100}%) scale(${isActive ? 1 : 0.85})`,
                            opacity: opacity,
                            pointerEvents: isActive ? 'auto' : 'none',
                            zIndex: isActive ? 2 : 1
                          }}
                        >
                          <img
                            src={imagem}
                            alt={`Cálculo Referência ${index + 1}`}
                            draggable="false"
                            style={{
                              boxShadow: isActive ? '0 12px 30px rgba(0,0,0,0.16)' : '0 4px 12px rgba(0,0,0,0.05)'
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <button className="ref-btn-nav" onClick={nextImage} style={{ zIndex: 3 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          </section>

          <div className="online-cta-bar">
            <div className="btn-group-wrapper">
              <a
                href="https://revisa-brasil.firebaseapp.com/cadastro?origem=site_antigo"
                className="btn-faca-revisao btn-solid"
              >
                <svg className="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>

                <div className="btn-text-stack">
                  <span className="btn-texto-principal">Avaliação Gratuita Online</span>
                </div>
              </a>
            </div>
          </div>

          {/* ======================================================== */}
          {/* CARDS DE INDICAÇÃO (RECOMENDADAS / NÃO RECOMENDADAS)     */}
          {/* ======================================================== */}
          <section className="indications-grid">
            <div className="status-card-wrapper">
              <div className="status-card green-card">
                <div className="status-header centered-header">
                  <div className="icon-circle bg-green">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <div className="status-header-text">
                    <h3>Revisões recomendadas</h3>
                    <span>Podem ser submetidas ao sistema</span>
                  </div>
                </div>

                <div className="tags-container">
                  <span className="badge">Tempo de Contribuição</span>
                  <span className="badge">Idade</span>
                  <span className="badge">Especial</span>
                  <span className="badge">Professor</span>
                </div>

                <div className="new-incapacity-badge">
                  <span className="new-text">
                    Aposentadoria por Incapacidade Previdenciária ou Acidentária
                  </span>
                </div>
              </div>
            </div>

            <div className="status-card-wrapper">
              <div className="status-card amber-card">
                <div className="status-header centered-header">
                  <div className="icon-circle bg-amber">
                    <span className="exclamation-mark">!</span>
                  </div>
                  <div className="status-header-text">
                    <h3 className="text-amber">Revisões não recomendadas</h3>
                    <span>Não devem ser submetidas ao sistema</span>
                  </div>
                </div>
                <ul className="negative-list">
                  <li>
                    <span><strong>Benefícios com valor do salário-mínimo:</strong> dificilmente haverá alteração.</span>
                  </li>
                  <li>
                    <span><strong>Benefícios concedidos há mais de 10 anos:</strong> operou a decadência, inviabilidade jurídica.</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

       {/* ======================================================== */}
          {/* SEÇÃO: DOCUMENTOS NECESSÁRIOS (ALINHADA E COM PNG)       */}
          {/* ======================================================== */}
          <section className="docs-necessarios-section">
            <div className="docs-header">
              <div className="icon-circle bg-green">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h2>Documentos necessários para fazer revisão</h2>
            </div>

            <p className="docs-subtitle-text">
              Tem dificuldade de acessar o site do governo para baixar a Carta de Concessão e o CNIS? Baixe nossa cartilha com o passo a passo:
            </p>

            <div className="cartilha-inner-card">
              <div className="cartilha-badge-wrapper">
                {/* Coloque aqui o caminho exato do seu PNG pronto */}
                <img
                  src="/assets/cartilha-icone.png"
                  alt="Cartilha Básica do Direito do Aposentado"
                  className="cartilha-img-icon"
                />
              </div>

              <h3 className="cartilha-card-title">
                Cartilha Básica do Direito do Aposentado
              </h3>

              <p className="cartilha-card-description">
                Aprenda a baixar sua Carta de Concessão e seu CNIS em poucos minutos.<br />
                Imprima a cartilha - sem reservas de direitos autorais.
              </p>

              <button
                type="button"
                onClick={handleDownloadCartilha}
                className="btn-download-cartilha"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span>Baixar Cartilha (PDF)</span>
              </button>
            </div>
          </section>

          {/* ======================================================== */}
          {/* VOCÊ RECEBERÁ                                            */}
          {/* ======================================================== */}
          <section className="deliverables">
            <h2>Você receberá</h2>

            <div className="deliverable-item">
              <div className="d-icon d-icon-green">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div className="d-text">
                <h4>Relatório com Efeitos Financeiros Positivos</h4>
                <p>
                  Detalhamento do resultado positivo encontrado, pontuados um a um; relação das provas a serem produzidas; esclarecimento sobre as provas e planilha comparativa completa dos cálculos de sua aposentadoria, mês a mês de perdas.
                </p>
                <h5 className="d-subtitle">Requerimento de revisão de cálculos:</h5>
                <p className="d-subtext">
                  Documento pronto, já personalizado, com o nome do aposentado.
                </p>
              </div>
            </div>

            <div className="deliverable-item">
              <div className="d-icon d-icon-navy">
                <span className="d-exclamation">!</span>
              </div>
              <div className="d-text">
                <h4>Relatório Sem Efeitos Financeiros Positivos</h4>
                <p>
                  Detalhamento do resultado encontrado, pontuados um a um e planilha comparativa completa dos cálculos de sua aposentadoria, mês a mês.
                </p>
              </div>
            </div>

            <div className="deliverable-item">
              <div className="d-icon d-icon-beige">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8C6239" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
              <div className="d-text">
                <h4>Revisão Negativa</h4>
                <p>
                  Detalhamento do resultado encontrado, pontuados um a um e planilha comparativa completa dos cálculos de sua aposentadoria, mês a mês.
                </p>
              </div>
            </div>
          </section>

          {/* AVISO DE PRAZO DE AUDITORIA (24HRS) */}
          <div className="resultado-conteudo">
            <div className="icone-relogio">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7V12L15.5 14.5" />
              </svg>
            </div>

            <p>
              <strong>Resultado auditado</strong> no prazo de <strong>24hrs</strong>, dia útil, observado o calendário oficial da cidade do Rio de Janeiro.
            </p>
          </div>

          {/* ======================================================== */}
          {/* PREÇO PROMOCIONAL                                        */}
          {/* ======================================================== */}
          <section className="pricing-section">
            <div className="national-info">
              <h2>Uso do Serviço em todo Brasil</h2>
              <div className="promo-price-container">

                <div className="old-price-box">
                  <span className="old-promo-label">VALOR</span>
                  <span className="old-price-amount">R$ 199,99</span>
                </div>

                <div className="new-price-box">
                  <span className="promo-label">VALOR PROMOCIONAL</span>
                  <span className="new-price-amount">R$ 89,99</span>
                </div>

                <div className="pix-inline">
                  <span className="pix-label">
                    <img alt="Pix" src="/assets/pixIconVerde.svg" className="pix-logo" />
                  </span>
                </div>

              </div>
            </div>
          </section>

          {/* ======================================================== */}
          {/* FAQ - PERGUNTAS FREQUENTES                               */}
          {/* ======================================================== */}
          <section className="faq-section">
            <h2 className="faq-main-title">Perguntas Frequentes</h2>

            <div className={`accordion-item ${activeIndex === 4 ? 'active' : ''}`}>
              <div className="accordion-title" onClick={() => toggleAccordion(4)}>
                Como funciona a avaliação gratuita?
                <span className="arrow">{activeIndex === 4 ? '▴' : '▾'}</span>
              </div>
              <div className="accordion-content">
                <p>
                  É uma análise preliminar das informações contidas na carta de concessão e do CNIS onde se detecta com precisão absoluta, o seguinte:
                </p> <br />
                <p><strong>a)</strong> se há erro nos cálculos da aposentadoria e se em caso de revisão, haverá ou não efeitos financeiros positivos;</p>
                <p><strong>b)</strong> sem erros nos cálculos da aposentadoria.</p>
                <br />
                <p>
                  Na análise preliminar não há emissão de relatórios e nem de eventuais requerimentos, apenas as informações contidas acima, quanto à existência ou não de erro e sobre os efeitos financeiros em eventual revisão.
                </p>
                <br />
                <p>
                  Para dar continuidade à revisão com efeitos financeiros positivos o usuário contrata o uso do sistema Revisa Já Aposentadoria que fornecerá os resultados com relatório e requerimentos de revisão personalizado.
                </p>
                <br />
                <p>
                  E ainda, o aposentado ainda que não tenha efeitos financeiros positivos mas que queira a integra do relatório, também poderá, de forma voluntaria, contratar o uso do Sistema Revisa Já para obter o relatório completo da análise de sua aposentadoria.
                </p>
                <br />
                <p>Quando for detectado erros nos cálculos da aposentadoria e efeitos financeiros econômicos positivo ou em qualquer outra situação, o uso do sistema Revisa Já Aposentadoria, <strong>custa hoje R$89,99.</strong></p>
                <br />
                <p>O resultado será encaminhado para o WhatsApp ou e-mail informado pelo aposentado.</p>
                <p>
                  <br />
                  <strong>ATT</strong><br />
                  <strong>REVISA JÁ ASSESSORIA LTDA.</strong>
                </p>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 1 ? 'active' : ''}`}>
              <div className="accordion-title" onClick={() => toggleAccordion(1)}>
                Por que quem ganha salário-mínimo não deve pedir revisão?
                <span className="arrow">{activeIndex === 1 ? '▴' : '▾'}</span>
              </div>
              <div className="accordion-content">
                <p>Não recomendamos; porque com salário do benefício no valor mínimo, muito provavelmente a revisão não resultará efeito financeiro positivo.</p>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 2 ? 'active' : ''}`}>
              <div className="accordion-title" onClick={() => toggleAccordion(2)}>
                Perda do direito de solicitar a revisão de um benefício após 10 anos.
                <span className="arrow">{activeIndex === 2 ? '▴' : '▾'}</span>
              </div>
              <div className="accordion-content">
                <p>A decadência do direito à revisão previdenciária é a perda do direito de solicitar a revisão de um benefício por não ter sido exercido dentro do prazo de 10 anos.</p>
                <p className="sitacao">
                  “Lei 8.213/91 - Art. 103. O prazo de decadência do direito ou da ação do segurado ou beneficiário para a revisão do ato de concessão, indeferimento, cancelamento ou cessação de benefício e do ato de deferimento, indeferimento ou não concessão de revisão de benefício é de 10 (dez) anos, contado:”
                </p>
                <p>O direito de revisão decai em 10 anos a contar do recebimento da primeira prestação da aposentadoria.</p>
                <p className="sitacao">
                  “Lei 8.213/91 - Art. 103, I - do dia primeiro do mês subsequente ao do recebimento da primeira prestação ou da data em que a prestação deveria ter sido paga com o valor revisto;”
                </p>
                <p>A decadência não ocorre a contar da data do início da aposentadoria e sim do recebimento da primeira prestação. Com efeito, ainda que a aposentadoria tenha iniciado em ano anterior a 2016, o fato a ser considerado é se o pagamento da primeira prestação se deu no ano de 2016.</p>
                <p>Veja o exemplo: Início da aposentadoria em 2015 e primeiro recebimento da prestação em 2016 - DECADÊNCIA EM 2026:</p>
                <img
                  id="faq-img"
                  src="/assets/decadencia.png"
                  alt="Exemplo de decadência"
                />
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 5 ? 'active' : ''}`}>
              <div className="accordion-title" onClick={() => toggleAccordion(5)}>
                O que é o resultado financeiro positivo?
                <span className="arrow">{activeIndex === 5 ? '▴' : '▾'}</span>
              </div>
              <div className="accordion-content">
                <p>É quando a auditoria identifica erros no cálculo do benefício que, após corrigidos, geram aumento no valor mensal da aposentadoria e/ou valores atrasados a receber. Acompanha relatório detalhado e requerimento de revisão personalizado.</p>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 6 ? 'active' : ''}`}>
              <div className="accordion-title" onClick={() => toggleAccordion(6)}>
                O que é o resultado sem efeito financeiro positivo?
                <span className="arrow">{activeIndex === 6 ? '▴' : '▾'}</span>
              </div>
              <div className="accordion-content">
                <p>Ocorre quando, embora possam existir divergências técnicas nos dados analisados, a revisão não traria aumento prático na renda mensal atual do segurado, evitando gastos ou processos desnecessários.</p>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 0 ? 'active' : ''}`}>
              <div className="accordion-title" onClick={() => toggleAccordion(0)}>
                Como funciona o Revisa Já Aposentadoria?
                <span className="arrow">{activeIndex === 0 ? '▴' : '▾'}</span>
              </div>
              <div className="accordion-content">
                <p>É um sistema especialmente desenvolvido para revisão de cálculos de aposentadorias, detectando todos os erros existentes mediante a materialidade que nos é fornecida: Carta de Concessão com memória de cálculo e CNIS.</p>
              </div>
            </div>
          </section>

          {/* --- SELOS DE SEGURANÇA --- */}
          <div className="security-seals-container">
            <h3 className="security-title">Ambiente Seguro e Protegido</h3>
            <div className="seals-grid">
              <div className="seal-item">
                <img src={seloSeguro} alt="Selo Site Seguro" />
              </div>
              <div className="seal-item">
                <img src={seloCloudflare} alt="Protegido por Cloudflare" />
              </div>
              <div className="seal-item">
                <img src={seloLgpd} alt="Adequado à LGPD" />
              </div>
              <div className="seal-item">
                <img src={seloMercadoPago} alt="Pagamento via Mercado Pago" />
              </div>
            </div>
          </div>

        </main>
      </div>
    </>
  );
};

export default AdvogadosParceiros;